import { money, fmtDate } from "../../lib/api";
import { TIER_META, PLAN_LABEL } from "../../lib/tiers";

const CLS = {
  pending: "bg-cyan-500/15 text-cyan-300",
  accepted: "bg-emerald-500/15 text-emerald-400",
  passed: "bg-white/10 text-slate-300",
  donated: "bg-rose-500/15 text-rose-300",
  bought: "bg-violet-500/15 text-violet-300",
};

export const AwardsList = ({ items }) => (
  <div className="lux-card overflow-x-auto" data-testid="admin-awards-table">
    <table className="w-full text-sm min-w-[760px]">
      <thead className="text-[10px] font-mono-lux tracking-[0.2em] uppercase text-slate-500 text-left">
        <tr className="border-b border-white/5"><th className="p-4">Member</th><th>Line</th><th>Reward</th><th>Status</th><th>Value</th><th>Scholarship</th><th>Date</th></tr>
      </thead>
      <tbody>
        {items.map((a) => (
          <tr key={a.id} data-testid={`admin-award-row-${a.id}`} className="border-b border-white/5">
            <td className="p-4">{a.user_name}{a.travel_date && <p className="text-[11px] text-amber-200/80">Travel {a.travel_date}</p>}</td>
            <td className="text-slate-400">{TIER_META[a.tier]?.short} · {PLAN_LABEL[a.plan]}</td>
            <td>{a.vacation_title}</td>
            <td><span className={`text-[10px] font-mono-lux uppercase px-2 py-0.5 rounded-full ${CLS[a.status]}`}>{a.status}{a.auto_accepted ? " (auto)" : ""}</span></td>
            <td className="font-mono-lux">{money(a.amount + a.extra_amount)}</td>
            <td className="text-slate-400">{a.charity_name ? `${money(a.charity_amount)} → ${a.charity_name}` : "—"}</td>
            <td className="font-mono-lux text-slate-500">{a.status === "pending" ? `due ${fmtDate(a.expires_at)}` : fmtDate(a.decided_at)}</td>
          </tr>
        ))}
        {items.length === 0 && <tr><td colSpan={7} className="p-6 text-slate-500">No offers yet.</td></tr>}
      </tbody>
    </table>
  </div>
);
